module.exports = __webpack_public_path__ + "assets/img/SEOClarity-Landing-Page-+-Website.91af6529.jpg";